(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67109,65250],{

/***/ 15147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcceptCreditWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/acceptcredit/logo/index.tsx


function AcceptCreditLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "610",
        height: "71",
        fill: "none",
        viewBox: "0 0 610 71",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#1B9B9B",
                clipPath: "url(#clip0_0_4)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M98.48 10.18h9.17l8.29 41.52h-8.35l-1.8-9.91H89.96l-5.22 9.91h-8.88l22.62-41.52zm6 24.41l-1.92-10.44-.58-5h-.46l-2.32 5-5.53 10.41 10.81.03zM133.57 52.63a15.279 15.279 0 01-5.57-1 12.794 12.794 0 01-4.38-2.75 12.557 12.557 0 01-2.84-4.23 14.094 14.094 0 01-1-5.43c-.011-2.194.4-4.37 1.21-6.41a16.516 16.516 0 013.48-5.36 16.922 16.922 0 015.51-3.71 18.392 18.392 0 017.31-1.39 13.56 13.56 0 018.12 2.29 11.394 11.394 0 014.35 6l-7.31 2.84c-1-2.74-3-4.12-6.2-4.12a8.829 8.829 0 00-3.57.73 8.33 8.33 0 00-2.81 2 9.407 9.407 0 00-2.5 6.41 7.857 7.857 0 00.53 2.9 6.58 6.58 0 001.42 2.26c.6.62 1.317 1.112 2.11 1.45a6.57 6.57 0 002.61.52 7.81 7.81 0 004.32-1.13 9.29 9.29 0 003-3.16l6.5 3.13a17.718 17.718 0 01-6.24 6.3 16.57 16.57 0 01-8.05 1.86zM164.89 52.63a15.279 15.279 0 01-5.57-1 12.794 12.794 0 01-4.38-2.75 12.415 12.415 0 01-2.88-4.22 14.094 14.094 0 01-1-5.43c-.011-2.194.4-4.37 1.21-6.41a16.516 16.516 0 013.48-5.36 16.923 16.923 0 015.51-3.71 18.359 18.359 0 017.31-1.39 13.56 13.56 0 018.12 2.29 11.394 11.394 0 014.35 6l-7.31 2.84c-1-2.74-3-4.12-6.2-4.12a8.829 8.829 0 00-3.57.73 8.33 8.33 0 00-2.81 2 9.407 9.407 0 00-2.5 6.41 7.857 7.857 0 00.53 2.9 6.58 6.58 0 001.42 2.26 6.365 6.365 0 002.11 1.45 6.51 6.51 0 002.61.52 7.81 7.81 0 004.32-1.13 9.29 9.29 0 003-3.16l6.5 3.13a17.718 17.718 0 01-6.24 6.3 16.57 16.57 0 01-8.01 1.85zM210.06 44.74a19.358 19.358 0 01-5.86 5.8 15.7 15.7 0 01-8.41 2.09 14.366 14.366 0 01-5.6-1 12.298 12.298 0 01-6.87-7.17 14.714 14.714 0 01-.93-5.24 16.785 16.785 0 011.22-6.33 17.15 17.15 0 013.42-5.36 16.26 16.26 0 015.34-3.74 16.93 16.93 0 017-1.39 14.62 14.62 0 015.48 1 11.531 11.531 0 013.94 2.58 10.711 10.711 0 012.41 3.77c.543 1.448.818 2.983.81 4.53.013 1.7-.261 3.39-.81 5h-21.4v.58a5.685 5.685 0 002.06 4.61 7.26 7.26 0 004.55 1.48 8.762 8.762 0 007.95-4.17l5.7 2.96zm-5.16-10.9v-.23a4.833 4.833 0 00-1.54-3.51 6.355 6.355 0 00-4.67-1.54 8.262 8.262 0 00-5 1.54 7.997 7.997 0 00-2.93 3.74h14.14zM235.64 22.36a10.92 10.92 0 014.7 1 11.444 11.444 0 013.72 2.8 12.484 12.484 0 012.44 4.23c.593 1.724.888 3.537.87 5.36a17.902 17.902 0 01-1.16 6.41 16.302 16.302 0 01-8.41 9.08 15 15 0 01-6.5 1.39 10.93 10.93 0 01-5.19-1.25 7.697 7.697 0 01-3.33-3.1h-.46l-.18 4.06-2.08 11.89h-7.59l7.25-40.95h7.07l-.58 3.43h.47a10.817 10.817 0 013.33-3 10.67 10.67 0 015.63-1.35zm-4.58 23.25a8.119 8.119 0 003.51-.75 8.821 8.821 0 002.76-2 9.158 9.158 0 001.79-3c.43-1.13.647-2.33.64-3.54a6.549 6.549 0 00-4.242-6.607 6.542 6.542 0 00-2.758-.393 8.001 8.001 0 00-3.25.7 8.772 8.772 0 00-2.75 1.91 9.392 9.392 0 00-1.91 3 9.764 9.764 0 00-.73 3.83 6.613 6.613 0 001.92 5 6.818 6.818 0 005.02 1.85zM260.53 52.63a9.089 9.089 0 01-6.09-2c-1.59-1.34-2.38-3.4-2.38-6.16 0-.43 0-.9.06-1.39a15.85 15.85 0 01.23-1.75l2-11.54h-5l1.16-6.5h5l1.55-8.73h7.59l-1.56 8.7h7l-1.11 6.5h-7l-1.92 11.3c-.053.254-.09.511-.11.77v.6a3.56 3.56 0 00.61 2.12 2.39 2.39 0 002.11.87 5.14 5.14 0 001.54-.2c.416-.141.816-.33 1.19-.56l1.16 6.91c-.836.363-1.712.625-2.61.78a19.61 19.61 0 01-3.42.28zM309.53 45.15a28.636 28.636 0 01-3.94 3.42 23.056 23.056 0 01-4.12 2.32 19.559 19.559 0 01-4.58 1.33c-1.746.28-3.512.418-5.28.41a20.001 20.001 0 01-7.36-1.33 17.575 17.575 0 01-6-3.83 18.004 18.004 0 01-4-6.06 20.727 20.727 0 01-1.48-8 23.384 23.384 0 011.86-9.25 23.918 23.918 0 015.16-7.69 24.653 24.653 0 017.89-5.25 25.64 25.64 0 0110.09-1.94c3.108-.075 6.19.579 9 1.91a16.005 16.005 0 016 5.22l-6.27 5.11a12.344 12.344 0 00-4-3.54 12.07 12.07 0 00-5.86-1.28 15.228 15.228 0 00-6.2 1.28 16.468 16.468 0 00-8.58 8.64 15.788 15.788 0 00-1.28 6.38 13.56 13.56 0 00.9 5 11.564 11.564 0 002.46 3.85 10.77 10.77 0 003.72 2.47c1.492.593 3.085.889 4.69.87 2.297.04 4.567-.49 6.61-1.54a22.913 22.913 0 005.51-4.15l5.06 5.65zM312.6 51.7l5-28.42h7.14l-.7 4h.46a12.636 12.636 0 013.6-3.45 9.29 9.29 0 015.16-1.42 7.753 7.753 0 012.47.32c.592.188 1.15.472 1.65.84l-2.84 6.78a10.138 10.138 0 00-1.48-.52 8.078 8.078 0 00-2.06-.23 7.425 7.425 0 00-5.54 2.3 11.148 11.148 0 00-2.87 6l-2.38 13.81-7.61-.01zM362.83 44.74a19.358 19.358 0 01-5.86 5.8 15.679 15.679 0 01-8.41 2.09 14.32 14.32 0 01-5.59-1 12.272 12.272 0 01-6.88-7.17 14.687 14.687 0 01-.92-5.24 16.76 16.76 0 011.21-6.33 17.349 17.349 0 013.43-5.36 16.118 16.118 0 015.33-3.74 16.93 16.93 0 017-1.39 14.588 14.588 0 015.48 1 11.531 11.531 0 013.94 2.58 10.711 10.711 0 012.41 3.77c.543 1.448.818 2.983.81 4.53.013 1.7-.261 3.39-.81 5h-21.4v.58a5.685 5.685 0 002.06 4.61 7.28 7.28 0 004.55 1.48 9.44 9.44 0 004.7-1.07 9.31 9.31 0 003.25-3.1l5.7 2.96zm-5.16-10.9v-.23a4.833 4.833 0 00-1.54-3.51 6.355 6.355 0 00-4.67-1.54 8.262 8.262 0 00-5 1.54 8.064 8.064 0 00-2.93 3.74h14.14zM379.42 52.63a11.058 11.058 0 01-4.7-1 10.764 10.764 0 01-3.66-2.77 12.931 12.931 0 01-2.44-4.26 16.002 16.002 0 01-.87-5.37 17.925 17.925 0 011.16-6.41 16.41 16.41 0 018.38-9.07 15.003 15.003 0 016.53-1.39 10.93 10.93 0 015.14 1.2 7.768 7.768 0 013.33 3.11h.47l.17-4.06 2.2-12.47h7.54l-7.31 41.52h-7.07l.58-3.42h-.46a10.994 10.994 0 01-3.34 3 10.67 10.67 0 01-5.65 1.39zM384 29.37a8.13 8.13 0 00-3.51.76 8.821 8.821 0 00-2.76 2 9.047 9.047 0 00-1.79 3 9.787 9.787 0 00-.64 3.53c-.046.932.1 1.864.429 2.738.328.874.832 1.67 1.481 2.342a6.919 6.919 0 005.05 1.88c1.12 0 2.227-.235 3.25-.69a8.994 8.994 0 002.75-1.92 9.226 9.226 0 001.91-3 9.764 9.764 0 00.73-3.83 6.613 6.613 0 00-1.92-5 6.818 6.818 0 00-4.98-1.81zM402.21 51.7l5-28.42h7.59l-5 28.42h-7.59zm10.32-32.24a4.85 4.85 0 113.45-1.42 4.733 4.733 0 01-3.45 1.42zM429.7 52.63a9.09 9.09 0 01-6.09-2c-1.59-1.34-2.38-3.4-2.38-6.16 0-.43 0-.9.06-1.39.06-.49.11-1.08.23-1.75l2-11.54h-5l1.16-6.5h5l1.57-8.7h7.6l-1.57 8.7h7l-1.1 6.5h-7l-1.91 11.3c-.06.253-.1.51-.12.77v.6a3.56 3.56 0 00.61 2.12 2.402 2.402 0 002.12.87 5.072 5.072 0 001.53-.2c.416-.141.816-.33 1.19-.56l1.16 6.91a11.26 11.26 0 01-2.61.78c-1.14.185-2.295.269-3.45.25zM445.18 51.7a4.933 4.933 0 01-3.56-1.42 4.626 4.626 0 01-1.48-3.45 4.51 4.51 0 01.371-1.865 4.516 4.516 0 011.109-1.545 5.24 5.24 0 017.13 0 4.544 4.544 0 011.48 3.41 4.658 4.658 0 01-1.48 3.45 5.006 5.006 0 01-3.57 1.42zM493.15 45.15a28.715 28.715 0 01-4 3.42 22.726 22.726 0 01-4.12 2.32 19.412 19.412 0 01-4.58 1.33 32.114 32.114 0 01-5.27.41 20.103 20.103 0 01-7.37-1.33 17.62 17.62 0 01-6-3.83 17.882 17.882 0 01-4-6.06 20.936 20.936 0 01-1.47-8 23.379 23.379 0 011.85-9.25 24.082 24.082 0 015.16-7.69 24.87 24.87 0 017.89-5.25 25.71 25.71 0 0110.09-1.94c3.125-.084 6.226.57 9.05 1.91a16.005 16.005 0 016 5.22l-6.26 5.11a12.452 12.452 0 00-4-3.54 12.07 12.07 0 00-5.86-1.28 15.27 15.27 0 00-6.21 1.28 16.628 16.628 0 00-5.1 3.48 16.419 16.419 0 00-3.48 5.16 16 16 0 00-1.28 6.38 13.56 13.56 0 00.9 5 11.442 11.442 0 002.47 3.85 10.728 10.728 0 003.71 2.47c1.495.592 3.092.888 4.7.87a14.002 14.002 0 006.61-1.54 23.099 23.099 0 005.58-4.09l4.99 5.59zM512.87 22.36c3.9 0 6.88.92 8.93 2.78a9.383 9.383 0 013.07 7.31c-.001.475-.031.949-.09 1.42-.05.48-.12 1-.2 1.54l-2.9 16.29h-7.48l.52-3h-.46a11.189 11.189 0 01-3.34 2.81 9.73 9.73 0 01-4.84 1.13 10.928 10.928 0 01-3.92-.67 8.736 8.736 0 01-3-1.85 8.294 8.294 0 01-1.94-2.84 9 9 0 01-.7-3.57 9.593 9.593 0 011-4.35 9.307 9.307 0 012.72-3.28 12.837 12.837 0 014.24-2.09 19.257 19.257 0 015.42-.72c1.313-.01 2.623.118 3.91.38 1.153.26 2.289.595 3.4 1l.23-.87c.07-.302.11-.61.12-.92a3.771 3.771 0 00-1.54-3.08 6.32 6.32 0 00-4-1.22 8.6 8.6 0 00-3.89.85 9.498 9.498 0 00-3 2.4l-5.11-3.71a13.662 13.662 0 015.69-4.32 19.051 19.051 0 017.16-1.42zm-4.3 24.35a6.998 6.998 0 002.76-.55 8.25 8.25 0 002.32-1.45 7.88 7.88 0 001.68-2.08c.43-.77.734-1.604.9-2.47a20.316 20.316 0 00-2.47-.9 12.418 12.418 0 00-3.68-.49 7.84 7.84 0 00-4.17 1.07 3.6 3.6 0 00-1.74 3.28 3.057 3.057 0 001.3 2.7 5.31 5.31 0 003.1.89zM526.67 51.7l5-28.42h7.13l-.7 4h.47a12.45 12.45 0 013.59-3.45 9.29 9.29 0 015.16-1.42 7.753 7.753 0 012.47.32c.593.186 1.151.47 1.65.84l-2.84 6.78a10.138 10.138 0 00-1.48-.52 8.081 8.081 0 00-2.06-.27 7.425 7.425 0 00-5.54 2.3 11.149 11.149 0 00-2.87 6l-2.37 13.81-7.61.03zM560.94 52.63a11 11 0 01-4.69-1 10.786 10.786 0 01-3.72-2.78 13.085 13.085 0 01-2.47-4.29 16.002 16.002 0 01-.87-5.37 17.724 17.724 0 011.16-6.41 16.312 16.312 0 018.38-9.07 14.94 14.94 0 016.52-1.39 10.87 10.87 0 015.19 1.24 7.751 7.751 0 013.34 3.11h.46l.18-4.06 2.2-12.47h7.54l-7.31 41.52h-7.07l.58-3.42h-.47a10.817 10.817 0 01-3.33 3 10.71 10.71 0 01-5.62 1.39zm4.58-23.26a8.12 8.12 0 00-3.5.76 8.6 8.6 0 00-2.76 2 9.264 9.264 0 00-1.8 3 10.008 10.008 0 00-.63 3.53 6.79 6.79 0 001.91 5.08 6.915 6.915 0 005 1.88 7.94 7.94 0 003.25-.69 9.001 9.001 0 002.76-1.92 9.226 9.226 0 001.91-3 9.934 9.934 0 00.73-3.83 6.613 6.613 0 00-1.92-5 6.848 6.848 0 00-4.95-1.81zM595.06 52.63a15.9 15.9 0 01-4.7-.64 12.233 12.233 0 01-3.63-1.74 10.41 10.41 0 01-2.55-2.58 11.567 11.567 0 01-1.54-3.16l7-2.84a4.82 4.82 0 002.12 3.25 7.848 7.848 0 007.19.32 2.252 2.252 0 001.36-2.06 2.283 2.283 0 00-.93-1.89 8.11 8.11 0 00-3-1.24l-3.08-.76a14.75 14.75 0 01-2.66-1 9.222 9.222 0 01-2.38-1.63 8.06 8.06 0 01-1.71-2.32 6.563 6.563 0 01-.67-3 7.43 7.43 0 011-3.8 8.631 8.631 0 012.64-2.82 12.57 12.57 0 013.94-1.76 18.75 18.75 0 014.93-.61c5.68 0 9.45 2.28 11.31 6.84l-7 2.55a4.07 4.07 0 00-1.86-2.4 5.92 5.92 0 00-3.13-.85 6.12 6.12 0 00-3.13.67 2.002 2.002 0 00-1.1 1.77c0 1.24 1.06 2.13 3.19 2.67l4 1a10.538 10.538 0 015.48 3 7.068 7.068 0 011.83 4.81 9 9 0 01-1 4.26 9.4 9.4 0 01-2.73 3.19 12.7 12.7 0 01-4.11 2 18.131 18.131 0 01-5.08.77zM50.646 10.864l-4.657 9.655 2.387 1.152 4.657-9.656-2.387-1.151zM44.188 24.26l-2.815 5.837 2.387 1.151 2.815-5.836-2.387-1.151z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M.15 62.25a3.92 3.92 0 002 2.39l10.79 5.2a3.86 3.86 0 005.16-1.8l3.15-6.53a6.1 6.1 0 012.6-2.74c1.6-.88 3.096-1.936 4.46-3.15l6.08 2.93 7.43 3.58.12.06a5.68 5.68 0 007.57-2.65l19.27-40a5.659 5.659 0 00-2.64-7.56l-.8-.39-7.94-3.83-15-7.22a5.69 5.69 0 00-7.57 2.64l-3.18 6.61-.16-.09a6.69 6.69 0 00-8 1.71l-.06.08-11.47 15.82a30.28 30.28 0 00-5.72 15.41l-.21 2.63A23.49 23.49 0 012.7 55.63L.56 59.15a3.88 3.88 0 00-.41 3.1zm43-2.45h-.09l21.9-45.41h.09a3 3 0 011.41 4l-19.28 40a3 3 0 01-1.72 1.54 3 3 0 01-2.34-.13h.03zm-6.36-3.07l21.9-45.4 3.88 1.87-21.93 45.36-3.85-1.83zm-6.43-3.1a24.997 24.997 0 003.74-5.61l5.22-10.84a2.617 2.617 0 00-1.22-3.5 8.24 8.24 0 00-9.19 1.35l-4.85 4.42a1.73 1.73 0 01-2.76-2l16-33.14a3 3 0 014-1.41l15 7.23-21.93 45.43-4.01-1.93z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H609.72V70.22H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (AcceptCreditLogo);

// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/styles/variables/acceptcreditVariables.module.scss
var acceptcreditVariables_module = __webpack_require__(91725);
var acceptcreditVariables_module_default = /*#__PURE__*/__webpack_require__.n(acceptcreditVariables_module);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/acceptcreditWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function AcceptCreditWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Accept Credit",
                    domain: "AcceptCredit.Cards"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Accept Credit",
                    domain: "AcceptCredit.Cards"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&family=Open+Sans:wght@400;700&family=Poppins:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Lato', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "TOP CREDIT CARD PROCESSING COMPANIES",
                        textColor: (acceptcreditVariables_module_default()).mainColor,
                        phoneNumberColor: (acceptcreditVariables_module_default()).mainColor,
                        iconColor: (acceptcreditVariables_module_default()).mainColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 91725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#1b9b9b","whyUs":"#316767"};

/***/ })

}]);